import { fork, put, select, take, call, takeLatest } from 'redux-saga/effects';
import { selectAPI } from '../../../api/API.sagas';
import { fetchSaveUploadedDocuments } from '../../../api/lendingAPI/LendingAPI';
import {
    API_GET_DOCUMENT_UPLOAD,
    API_GET_DOCUMENT_UPLOAD_SUCCESS
} from '../../../api/lendingAPI/LendingAPI.actions';
import { CLOSE_MODAL, OPEN_MODAL } from '../../../iwModals/Modals.actions';
import { TRADING_DATA_UPLOADED_DOCOUMENTS } from '../../tradingData/TradingData.actions';
import { CHOOSE_DOCUMENT_TYPE } from './chooseDocumentType/ChooseDocumentType.actions';
import { DOCUMENT_UPLOADER } from './documentUploader/DocumentUploader.actions';
import {
    ADD_TO_DOCUMENT_PENDING_LIST,
    SHOW_UPLOAD_DOCUMENTS_MODAL,
    UPDATE_DOCUMENT_STATUS_ON_COMPLETED,
    UPDATE_DOCUMENT_STATUS_ON_ERROR,
    UPLOAD_DOCUMENT
} from './UploadDocumentsModal.actions';
import { serialiseDocument } from './UploadDocumentsModalHelper';
import { GoogleTagManager } from '@iwoca/frontend-tracking-library';

export const uploadDocumentsModalSagaWorkers = [
    fork(showUploadDocumentsModal),
    fork(uploadDocument),
    fork(trackUploadDocumentsModalWorker)
];

function* showUploadDocumentsModal() {
    yield takeLatest(SHOW_UPLOAD_DOCUMENTS_MODAL, function* (action) {
        const hasProvidedDocumentType = !!action.documentType;
        const { customer_state } = yield selectAPI();

        switch (true) {
            case hasProvidedDocumentType:
                yield put({
                    type: DOCUMENT_UPLOADER,
                    preventBackNavigation: action.preventBackNavigation,
                    documentType: action.documentType,
                    customer_state
                });
                break;
            default:
                yield put({ type: CHOOSE_DOCUMENT_TYPE, customer_state });
                break;
        }

        yield put({
            type: OPEN_MODAL,
            id: 'UploadDocumentsModal'
        });

        yield take(CLOSE_MODAL);

        yield put({ type: API_GET_DOCUMENT_UPLOAD });
        yield take(API_GET_DOCUMENT_UPLOAD_SUCCESS);
        const { document_upload } = yield selectAPI();
        yield put({ type: TRADING_DATA_UPLOADED_DOCOUMENTS, document_upload });
    });
}

function* uploadDocument() {
    yield takeLatest(UPLOAD_DOCUMENT, function* (action) {
        const documents = action.documents;
        yield documents.map((document) =>
            call(uploadSingleFile, document, action)
        );
    });
}

function* trackUploadDocumentsModalWorker() {
    yield takeLatest(DOCUMENT_UPLOADER, function* (action) {
        const documentType = action?.documentType?.label;

        GoogleTagManager.trackModal({
            interaction: 'Open',
            modalName: `${documentType}UploaderModal`
        });

        yield take(CLOSE_MODAL);

        GoogleTagManager.trackModal({
            interaction: 'Close',
            modalName: `${documentType}UploaderModal`
        });
    });
}

function* handleDocumentUploadSuccess(response) {
    const successResponse = response[0];
    yield put({ type: UPDATE_DOCUMENT_STATUS_ON_COMPLETED, successResponse });
}

function* handleDocumentUploadError(response, document) {
    const errorCode = response[0].errors[0].code;
    const deserialisedErrorResponse = { errorCode, document };

    yield put({
        type: UPDATE_DOCUMENT_STATUS_ON_ERROR,
        deserialisedErrorResponse
    });
}

function* uploadSingleFile(document, action) {
    yield put({
        type: ADD_TO_DOCUMENT_PENDING_LIST,
        document: {
            name: document.name,
            type: action.documentType.value,
            pending: true
        }
    });

    const body = serialiseDocument(document, action.documentType.value);
    //TODO Parallel calls should go through the API sagas to serialise/deserialise
    const impersonatingStateKey = yield select(
        ({ history }) => history.impersonatingStateKey
    );

    const serialiseBody = { impersonatingStateKey, body };
    const response = yield call(fetchSaveUploadedDocuments, serialiseBody);
    yield handleResponse(response, document);
}

function* handleResponse(response, document) {
    if (response[0].data) {
        yield handleDocumentUploadSuccess(response);
    } else {
        yield handleDocumentUploadError(response, document);
    }
}
